<template>
  <the-modal-overlay :closable="modal.closable" v-show="modal.opened">
    <component :is="currentModal"></component>
  </the-modal-overlay>
</template>

<script>
import TheModalOverlay from "@/components/TheModalOverlay"
import { mapGetters } from "vuex"

export default {
  components: {
    TheModalOverlay,
    // importing modals on demand
    "modal-custom-request": () =>
      import("@/views/VideoCatalog/components/ModalCustomRequest.vue"),
    "modal-add-to-planning": () =>
      import("@/views/VideoCatalog/components/ModalAddToplanning.vue"),
    "modal-confirm-add-to-planning": () =>
      import("@/views/VideoCatalog/components/ModalConfirmAddToPlanning.vue"),
    "modal-pharmacy-blueprint-admin": () =>
      import("@/views/Account/components/ModalPharmacyBlueprintAdmin.vue"),
    "modal-sponsored-thumbnail-admin": () =>
      import("@/views/Account/components/SponsoredVideoThumbnailAdmin.vue"),
    "modal-pharmacy-blueprint-user": () =>
      import("@/views/Account/components/ModalPharmacyBlueprintUser.vue"),
    "modal-matterport": () =>
      import("@/views/Account/components/ModalMatterport.vue"),
    "modal-planned-video": () =>
      import("@/views/Planning/components/ModalPlannedVideo.vue"),
    "modal-grouping-planned-video": () =>
      import("@/views/Grouping/Planning/components/ModalPlannedVideo.vue"),
    "modal-confirm-planning-validation": () =>
      import("@/views/Planning/components/ModalConfirmPlanningValidation.vue"),
    "modal-video-edit-form": () =>
      import("@/views/FreelancerVideosList/components/ModalVideoEditForm.vue"),
    "modal-campaign-edit-form": () =>
      import(
        "@/views/FreelancerCampaignsList/components/ModalCampaignEditForm.vue"
      ),
    // admin videos list modals
    "modal-confirm-video-delete--admin": () =>
      import("@/views/AdminVideosList/components/ModalConfirmVideoDelete.vue"),
    "modal-add-video-form--admin": () =>
      import("@/views/AdminVideosList/components/ModalAddVideoForm.vue"),
    "modal-edit-video-form--admin": () =>
      import("@/views/AdminVideosList/components/ModalEditVideoForm.vue"),
    "modal-show-video--admin": () =>
      import("@/views/AdminVideosList/components/ModalShowVideo.vue"),
    // admin sponsored videos list modals
    "modal-edit-sponsored-video-form--admin": () =>
      import(
        "@/views/AdminSponsoredVideosList/components/ModalEditSponsoredVideoForm.vue"
      ),
    "modal-show-sponsored-video--admin": () =>
      import(
        "@/views/AdminSponsoredVideosList/components/ModalShowSponsoredVideo.vue"
      ),
    // annnoceur sponsored videos list modals
    "modal-confirm-sponsored-video-delete--annon": () =>
      import(
        "@/views/AnnonceurVideosList/components/ModalConfirmSponsoredVideoDelete.vue"
      ),
    "modal-add-sponsored-video-form--annon": () =>
      import(
        "@/views/AnnonceurVideosList/components/ModalAddSponsoredVideoForm.vue"
      ),
    "modal-edit-sponsored-video-form--annon": () =>
      import(
        "@/views/AnnonceurVideosList/components/ModalEditSponsoredVideoForm.vue"
      ),
    "modal-show-sponsored-video--annon": () =>
      import(
        "@/views/AnnonceurVideosList/components/ModalShowSponsoredVideo.vue"
      ),
    // plannings
    "modal-add-planning-form--admin": () =>
      import("@/views/AdminPlanningsList/components/AddPlanningModal.vue"),
    "modal-edit-planning-form--admin": () =>
      import("@/views/AdminPlanningsList/components/EditPlanningModal.vue"),
    "modal-confirm-planning-delete--admin": () =>
      import(
        "@/views/AdminPlanningsList/components/ConfirmPlanningDeleteModal.vue"
      ),
    // admin users list modals
    "modal-show-user--admin": () =>
      import("@/views/AdminUsersList/components/ModalShowUser.vue"),
    "modal-add-user-form--admin": () =>
      import("@/views/AdminUsersList/components/ModalAddUserForm.vue"),
    "modal-confirm-user-delete--admin": () =>
      import("@/views/AdminUsersList/components/ModalConfirmUserDelete.vue"),
    "modal-edit-user-form--admin": () =>
      import("@/views/AdminUsersList/components/ModalEditUserForm.vue"),
    // admin brand list modals
    "modal-add-brand-form--admin": () =>
      import("@/views/AdminBrandsList/components/ModalAddBrandForm.vue"),
    "modal-edit-brand-form--admin": () =>
      import("@/views/AdminBrandsList/components/ModalEditBrandForm.vue"),
    "modal-confirm-brand-delete--admin": () =>
      import("@/views/AdminBrandsList/components/ModalConfirmBrandDelete.vue"),
    "modal-import-brands-form--admin": () =>
      import("@/views/AdminBrandsList/components/ModalImportLabos.vue"),
    // admin themes list modals
    "modal-add-theme-form--admin": () =>
      import("@/views/AdminThemesList/components/ModalAddThemeForm.vue"),
    "modal-edit-theme-form--admin": () =>
      import("@/views/AdminThemesList/components/ModalEditThemeForm.vue"),
    "modal-confirm-theme-delete--admin": () =>
      import("@/views/AdminThemesList/components/ModalConfirmThemeDelete.vue"),
    // admin supports list modals
    "modal-add-support-form--admin": () =>
      import("@/views/AdminSupportsList/components/ModalAddSupportForm.vue"),
    "modal-edit-support-form--admin": () =>
      import("@/views/AdminSupportsList/components/ModalEditSupportForm.vue"),
    "modal-confirm-support-delete--admin": () =>
      import(
        "@/views/AdminSupportsList/components/ModalConfirmSupportDelete.vue"
      ),
    // admin support types list modals
    "modal-add-support-type-form--admin": () =>
      import(
        "@/views/AdminSupportsTypesList/components/ModalAddSupportTypeForm.vue"
      ),
    "modal-edit-support-type-form--admin": () =>
      import(
        "@/views/AdminSupportsTypesList/components/ModalEditSupportTypeForm.vue"
      ),
    "modal-confirm-support-type-delete--admin": () =>
      import(
        "@/views/AdminSupportsTypesList/components/ModalConfirmSupportTypeDelete.vue"
      ),
    // admin campaigns list modals
    "modal-show-campaign--admin": () =>
      import("@/views/AdminCampaignsList/components/ModalShowCampaign.vue"),
    "modal-edit-campaign-form--admin": () =>
      import("@/views/AdminCampaignsList/components/ModalEditCampaignForm.vue"),
    "modal-confirm-campaign-delete--admin": () =>
      import(
        "@/views/AdminCampaignsList/components/ModalConfirmCampaignDelete.vue"
      ),
    // Supports selection modal
    "modal-support-selection": () =>
      import(
        "@/views/Grouping/components/CampaignSelection/components/SupportSelection.vue"
      ),
    "modal-support-grouping-selection": () =>
      import("@/views/Grouping/VideoCatalog/components/ModalAddToplanning.vue"),
    "modal-contact-us": () =>
      import("@/views/Layout/components/ModalContactUs.vue"),
    // admin sliders list modals
    "modal-add-sliders-form--admin": () =>
      import("@/views/AdminSlidersList/components/ModalAddSlidersForm.vue"),
    "modal-edit-sliders-form--admin": () =>
      import("@/views/AdminSlidersList/components/ModalEditSlidersForm.vue"),
    "modal-confirm-sliders-delete--admin": () =>
      import(
        "@/views/AdminSlidersList/components/ModalConfirmSlidersDelete.vue"
      ),
    // admin packs list modals
    "modal-add-packs-form--admin": () =>
      import("@/views/AdminPacksList/components/ModalAddPacksForm.vue"),
    "modal-edit-packs-form--admin": () =>
      import("@/views/AdminPacksList/components/ModalEditPacksForm.vue"),
    "modal-confirm-packs-delete--admin": () =>
      import("@/views/AdminPacksList/components/ModalConfirmPacksDelete.vue"),
    //Stripe modal
    "modal-stripe": () => import("@/components/Stripe"),
    // admin prices list modals
    "modal-add-price-form--admin": () =>
      import("@/views/AdminCompetitorPrice/components/ModalAddPriceForm.vue"),
    "modal-edit-price-form--admin": () =>
      import("@/views/AdminCompetitorPrice/components/ModalEditPriceForm.vue"),
    "modal-confirm-price-delete--admin": () =>
      import(
        "@/views/AdminCompetitorPrice/components/ModalConfirmPriceDelete.vue"
      ),
    "modal-import-price-form--admin": () =>
      import(
        "@/views/AdminCompetitorPrice/components/ModalImportPriceForm.vue"
      ),
    /* Slot purchasing modal */
    "modal-purchase-slot": () =>
      import("@/views/Planning/components/PurchaseSlotModal.vue"),
    /* Campaigns modal */
    "modal-campaigns-requests": () => import("@/components/CampaignsModal.vue"),
    "modal-edit-cdc-campaign": () => import("@/components/EditCdcCampaign.vue"),
    "modal-view-pharmacies": () => import("@/components/ViewPharmacies.vue")
  },
  computed: {
    ...mapGetters(["modal"]),
    currentModal() {
      if (!this.modal.name) return null
      return `modal-${this.modal.name}`
    }
  }
}
</script>
